import { PDFDocument } from "pdf-lib";

// 24/10/2026 (Bartel): het ondertekenen van een pdf (bv. het RAMI-mandaat) gebeurt in de app zelf,
// zodat het in elke browser werkt - op de pc in Chrome/Edge/Firefox, op de gsm in Safari/Chrome -
// zonder Acrobat. De werker tekent op een canvas, tikt op het document waar de handtekening (of een
// stukje tekst) moet komen, en dit bestand plakt die als afbeelding in de pdf.
//
// Een plaatsing: { page (0-based), x, y, w: fracties van de paginabreedte/-hoogte (0..1, oorsprong
// linksboven zoals op het scherm), png: dataURL of bytes, ratio: hoogte/breedte van de afbeelding }.
// Tekst wordt vóór het plaatsen al naar een png getekend (zie SignPdfDialog), zodat ook namen in het
// Cyrillisch werken zonder een lettertype in de pdf te moeten inbedden.

const dataUrlToBytes = (dataUrl) => {
    const base64 = String(dataUrl).split(",")[1] || "";
    const bin = atob(base64);
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
};

export const stampPdf = async (originalBytes, placements) => {
    const pdfDoc = await PDFDocument.load(originalBytes, { ignoreEncryption: true });
    const pages = pdfDoc.getPages();
    const cache = new Map();

    for (const item of placements) {
        const page = pages[item.page];
        if (!page) continue;
        const key = typeof item.png === "string" ? item.png : item;
        let image = cache.get(key);
        if (!image) {
            const bytes = typeof item.png === "string" ? dataUrlToBytes(item.png) : item.png;
            image = await pdfDoc.embedPng(bytes);
            cache.set(key, image);
        }
        const { width: pw, height: ph } = page.getSize();
        const w = item.w * pw;
        const h = w * (item.ratio || image.height / image.width);
        page.drawImage(image, {
            x: item.x * pw,
            y: ph - item.y * ph - h,
            width: w,
            height: h,
        });
    }
    return pdfDoc.save();
};
